import React from 'react'
import { formatToCNPJ, formatToCPF, isCNPJ, isCPF } from 'brazilian-values'
import { PROCESS_TYPES_MESSAGES } from 'utils/constants/types'
import { StyleSheet, Text, View } from "@react-pdf/renderer"
// eslint-disable-next-line import/no-named-default
import { default as lodash } from 'lodash'
import { formatInBrazilianDate, isDate } from 'utils/functions'
import { DataField } from "../../../../Label"
import { infos } from "../../../../../ExpandedInfo/BgcExpansible/ProcessRow/fieldsInfo"

const styles = StyleSheet.create({
  label: {
    marginBottom: 16,
  },
  content: {
    marginBottom: 8,
    marginTop: 8,
  },
  details: {
    paddingLeft: 8,
    paddingRight: 8,
  },
})
const ProcessRow = (props) => {
  const { processData } = props

  const formatContent = (content) => {
    if (isDate(content)) return formatInBrazilianDate(content)

    if (isCPF(content)) return formatToCPF(content)
    if (isCNPJ(content)) return formatToCNPJ(content)
    return content
  }
  const renderField = (item, fieldVal) => {
    const content = item

    if (lodash.isString(content) || lodash.isBoolean(content)) {
      return (
        <View>
          <DataField label={`${fieldVal}:`} value=
            {lodash.isString(content) ? formatContent(content) : content ? 'Sim' : 'Não'}
          />
        </View>
      )
    }

    return null
  }
  const renderProcessContent = (info, fieldVal) => {
    return renderField(info, fieldVal)
  }

  const renderOtherInfos = (process) => {
    if (
      lodash
        .chain(process?.data)
        .pick(lodash.keys(lodash.get(infos.options, 'fields')))
        .every(lodash.isEmpty)
        .value()
    ) {
      return <Text>N/A</Text>
    }

    return (
      <View>
        {lodash
          .map(infos.options.fields, (fieldVal, fieldKey) => {
            const info = lodash.get(process?.data, fieldKey)
            return info && fieldVal ? (
              <View key={fieldKey}>
                {renderProcessContent(info, fieldVal, fieldKey)}
              </View>
            ) : null
          })
          .filter((item) => item !== null)}
      </View>
    )
  }

  return (
    <View style={styles.content}>
      <DataField label={processData.court_description} value='' />

      {processData?.data?.cpf && (
        <DataField label="CPF:" value={formatToCPF(processData?.data?.cpf)} />
      )}

      {processData?.data?.envolved_kind && (
        <DataField
          label="Tipo envolvido:"
          value={processData?.data?.envolved_kind === 'POLE_PASSIVE' ? 'Polo Passivo' : ''}
        />
      )}

      {processData?.has_number && (
        <DataField label="Número do processo:" value={processData?.number} />
      )}

      {processData?.subject && (
        <DataField label="Assunto:" value={processData?.subject} />
      )}

      {processData?.type && (
        <DataField label="Tipo de processo:" value={PROCESS_TYPES_MESSAGES[processData?.type]} />
      )}

      <DataField
        label="Contém palavras chaves de risco:"
        value={processData?.contains_risk_keyword ? 'Sim' : 'Não'}
      />
      <DataField label="É pendencia financeira: " value={processData?.is_financial_penalty ? 'Sim' : 'Não'} />

      <DataField label="Dados do processo:" value='' />
      <View style={styles.details}>
        {renderOtherInfos(processData)}
      </View>
    </View>
  )
}

export default ProcessRow
